module.exports = {"TXTWCL_Browse_tournaments":{"id":"TXTWCL_Browse_tournaments","defaultMessage":"Turniere durchsuchen","track":"Browse tournaments"}}